import ipadAirIcon from '@/assets/device-icons/ipad-air.svg';

interface IpadAirIconProps {
  className?: string;
}

export const IpadAirIcon = ({ className = "h-5 w-5" }: IpadAirIconProps) => {
  return (
    <img 
      src={ipadAirIcon} 
      alt="iPad Air" 
      className={className}
    />
  );
};
